import { gql } from "@apollo/client";

export const GET_STAND_COMMENTS = gql`
    query GetStandComments(
        $text: String
        $where: QueryCommentsWhereWhereConditions
        $orderBy: [QueryCommentsOrderByOrderByClause!]
        $first: Int
        $page: Int
    ) {
        comments(text: $text, where: $where, orderBy: $orderBy, first: $first, page: $page) {
            paginatorInfo {
                total
                count
                currentPage
                perPage
                lastPage
            }
            data {
                id
                modelable_type
                modelable_id
                content
                status
                user_id
                created_at
                updated_at
                relAttachments {
                    id
                    path
                    server_name
                    original_name
                    extension
                    modelable_id
                    created_at
                }
                relUser {
                    id
                    name
                    surname
                }
            }
        }
    }
`;

export const GET_STAND_COMMENT = gql`
    query GetStandComment($id: ID!) {
        comment(id: $id) {
            id
            modelable_type
            modelable_id
            content
            status
            user_id
            created_at
            updated_at
            relAttachments {
                id
                path
                server_name
                original_name
                extension
                modelable_id
                created_at
            }
            relUser {
                id
                name
                surname
            }
        }
    }
`;
